'use es6';

import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import SyncHashTestFlagsToReduxContainer from 'ContentEditorUI/components/SyncHashTestFlagsToReduxContainer';
import SyncQueryParamsToReduxContainer from 'ContentEditorUI/components/SyncQueryParamsToReduxContainer';
import ReadOnlyFireAlarm from 'ContentEditorUI/components/app/ReadOnlyFireAlarm';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import TinyMceModals from 'ContentEditorUI/components/modals/TinyMceModals';
import UpgradeEventListener from 'ContentEditorUI/components/UpgradeEventListener';
import StyleCssMonitorContainer from 'ContentEditorUI/containers/StyleCssMonitorContainer';
import ModuleMarkupRequestContainer from 'ContentEditorUI/containers/ModuleMarkupRequestContainer';
import SectionMarkupRequestContainer from 'ContentEditorUI/containers/SectionMarkupRequestContainer';
import AutoHidePreviewFrameWhenDragDropModalIsOpen from 'ContentEditorUI/components/app/AutoHidePreviewFrameWhenDragDropModalIsOpen';
import InpageMessengerContainer from 'ContentEditorUI/containers/InpageMessengerContainer';
import TrackCriticalAssetFailuresWithRaven from 'ContentEditorUI/components/tracking/TrackCriticalAssetFailuresWithRaven';
import ShowUnexpectedPreviewUnloadWarning from 'ContentEditorUI/components/tracking/ShowUnexpectedPreviewUnloadWarning';
import CleanupBaymaxSkeleton from 'ContentEditorUI/components/CleanupBaymaxSkeleton';
import PreviewDomainDebugger from 'ContentEditorUI/components/PreviewDomainDebugger';
import EditorIframesCoordinator from 'ContentEditorUI/containers/EditorIframesCoordinator';
import ApplyChangesModal from 'ContentEditorUI/components/modals/ApplyChangesModal';
import DeleteRequestModalContainer from 'ContentEditorUI/containers/DeleteRequestModalContainer';
import { getIsInDeveloperMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { isApplyChangesModalOpen } from 'ContentEditorUI/redux/selectors/modalSelectors';
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import FilePickerProxyContainer from './FilePickerProxyContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    applyChangesModalOpen: isApplyChangesModalOpen(state),
    isInDeveloperMode: getIsInDeveloperMode(state)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    autoSave: opts => dispatch(ownProps.autoSaveAction(opts))
  };
};
class CoreEditorComponents extends Component {
  render() {
    const {
      applyChangesModalOpen,
      autoSave,
      isInDeveloperMode,
      hasIframe
    } = this.props;
    // TODO, put a comment with each of these saying why they are core
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(SyncHashTestFlagsToReduxContainer, {}), /*#__PURE__*/_jsx(SyncQueryParamsToReduxContainer, {
        path: window.location.search
      }), hasIframe && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(TrackCriticalAssetFailuresWithRaven, {}), /*#__PURE__*/_jsx(ShowUnexpectedPreviewUnloadWarning, {}), /*#__PURE__*/_jsx(InpageMessengerContainer, {}), /*#__PURE__*/_jsx(FilePickerProxyContainer, {}), /*#__PURE__*/_jsx(ModuleMarkupRequestContainer, {
          autoSave: autoSave
        }), /*#__PURE__*/_jsx(SectionMarkupRequestContainer, {}), /*#__PURE__*/_jsx(StyleCssMonitorContainer, {}), /*#__PURE__*/_jsx(PreviewDomainDebugger, {}), /*#__PURE__*/_jsx(EditorIframesCoordinator, {}), /*#__PURE__*/_jsx(AutoHidePreviewFrameWhenDragDropModalIsOpen
        // This is a work around for a chrome bug that seems to have been closed. Should look into seeing if we can remove this.
        , {}), applyChangesModalOpen && /*#__PURE__*/_jsx(ApplyChangesModal, {
          autoSave: autoSave
        }), /*#__PURE__*/_jsx(TinyMceModals, {})]
      }), /*#__PURE__*/_jsx(DeleteRequestModalContainer, {}), /*#__PURE__*/_jsx(CleanupBaymaxSkeleton, {}), /*#__PURE__*/_jsx(ReadOnlyFireAlarm, {}), /*#__PURE__*/_jsx(UIFloatingAlertList, {}), /*#__PURE__*/_jsx(UpgradeEventListener, {}), /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
        children: ({
          CopyAsHublContainer
        }) => {
          return /*#__PURE__*/_jsx(_Fragment, {
            children: isInDeveloperMode && /*#__PURE__*/_jsx(CopyAsHublContainer, {})
          });
        }
      })]
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CoreEditorComponents);